import { api } from "@/api"
import { useQuery } from "@tanstack/vue-query"

type HeatmapResponseItem = {
  dayOfWeek: 1 | 2 | 3 | 4 | 5 | 6 | 7
  transactionCount: number
}

type GratuityHeatmapResponse = {
  data: Array<HeatmapResponseItem>
}

const retrieveGratuityHeatmap =
  async (): Promise<GratuityHeatmapResponse> => {
    const { body } = await api.get<GratuityHeatmapResponse>(
      "/reports/gratuity/heatmap/"
    )
    return body
  }

const BASE_GRATUITY_HEATMAP_QUERY_KEY = "gratuity-heatmap"

export const useGratuityHeatmap = () =>
  useQuery(
    [BASE_GRATUITY_HEATMAP_QUERY_KEY] as const,
    retrieveGratuityHeatmap,
    {
      staleTime: Infinity,
    }
  )
